import { render, staticRenderFns } from "./PurchaseStatus.vue?vue&type=template&id=53b2ee42&"
import script from "./PurchaseStatus.vue?vue&type=script&lang=js&"
export * from "./PurchaseStatus.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports